export enum TaskStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum FileType {
  INPUT = 'input',
  OUTPUT = 'output',
}

export interface TaskFile {
  id: number;
  task_id: number;
  iteration_id: number | null;
  file_name: string;
  file_type: FileType;
  file_size: number;
  uploaded_at: string;
}

export interface TaskIteration {
  id: number;
  task_id: number;
  iteration_number: number;
  user_prompt: string | null;
  agent_report: string | null;
  status: TaskStatus;
  created_at: string;
  completed_at: string | null;
  output_files: TaskFile[];
}

export interface Task {
  id: number;
  title: string;
  description: string;
  status: TaskStatus;
  unread: boolean;
  created_by: number;
  created_at: string;
  updated_at: string;
  iterations: TaskIteration[];
  files: TaskFile[];
  knowledge_bases?: Array<{
    id: number;
    title: string;
    is_default: boolean;
    resource_count: number;
  }>;
}

export interface TaskTagSummary {
  id: number;
  name: string;
  color: string | null;
  full_path: string;
  user_id: number;
  is_own_tag: boolean;
}

export interface TaskTag {
  id: number;
  name: string;
  parent_id: number | null;
  user_id: number;
  color: string | null;
  created_at: string;
  updated_at: string;
  task_count: number;
}

export interface TaskTagTreeNode {
  id: number;
  name: string;
  parent_id: number | null;
  color: string | null;
  task_count: number;
  children: TaskTagTreeNode[];
}

export interface TaskListItem {
  id: number;
  title: string;
  description: string;
  status: TaskStatus;
  unread: boolean;
  archived: boolean;
  created_by: number;
  created_at: string;
  updated_at: string;
  created_by_username?: string;
  created_by_fullname?: string;
  project_name?: string;
  tags?: TaskTagSummary[];
}

export interface TaskCreateRequest {
  title: string;
  description: string;
  knowledge_base_ids?: number[];
  is_draft?: boolean;
  project_id?: number | null;
}

export interface TaskIterationCreateRequest {
  user_prompt: string;
}
